import { useTranslation } from 'react-i18next'
import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'
import { useGET_groupCourseSessionsSelectQuery } from 'redux/api/sessionsApi'
import { useGET_groupSelectQuery } from 'redux/api/groupsApi'
import { Grid } from '@mui/material'
import formModel, { initialValues } from 'utils/formModels/teacherSessionFilterModel'
import DatePickerField from 'components/atoms/fields/DatePickerField'
import { Form, Formik } from 'formik'
import SelectField from 'components/atoms/fields/SelectField'
import { useState } from 'react'
import SessionAttendanceForm from 'components/organisms/forms/SessionAttendanceForm'

const TeacherAttendancePage = () => {
  const { t } = useTranslation()

  const { 
    date, 
    group, 
    group_course_session,
  } = formModel()

  const [session, setSession] = useState(null)
  
  return ( <>
        <PageHeading title={t('common.attendance')} />
        <PageBody>

            <div>{t('common.select-students-criteria')}</div>

            <Formik
                enableReinitialize
                initialValues={initialValues}
                onSubmit={(values) => {}}
                >{({ values }) => (
                    <Form>
                        <Grid container spacing={4} sx={{ marginTop: '-1rem', marginBottom: '2rem' }}>
                            <Grid item xs={8} md={3}>
                                <DatePickerField fieldProps={{ ...date }}  maxDate={new Date()}  />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <SelectField
                                    fieldProps={{ ...group }}
                                    apiCall={useGET_groupSelectQuery}
                                />
                            </Grid>

                            {(values?.date && values?.group?.id) && 
                            <Grid item xs={12} lg={4}>
                                <SelectField
                                    fieldProps={{ ...group_course_session }}
                                    apiCall={useGET_groupCourseSessionsSelectQuery}
                                    filters={{
                                        start_date_from: values?.date ?? '',
                                        start_date_to: values?.date ?? '',
                                        group: values?.group?.id ?? '',
                                        ordering: 'start_datetime'
                                    }}
                                    onChange={(value) => {
                                        setSession(value)
                                    }}
                                />
                            </Grid>
                            }
                        </Grid>
                    </Form>
                )}
            </Formik>
            

            {session && <SessionAttendanceForm session={session} viewOnly={false} />}
             
        </PageBody>
      </> 
    
  )
}
export default TeacherAttendancePage

